import { isNativeMobile } from '../mobile/capacitor'

export const ANALYTICS_IGNORE_KEY = 'optioneer_analytics_ignore'

/** Marketing vendors belong only to the production website, never app/sandbox builds. */
export function isWebMeasurementAllowed(): boolean {
  if (
    import.meta.env.DEV ||
    import.meta.env.MODE === 'mobile' ||
    import.meta.env.VITE_ENVIRONMENT !== 'production' ||
    import.meta.env.VITE_ANALYTICS_DISABLED === 'true' ||
    isNativeMobile() ||
    typeof window === 'undefined'
  )
    return false

  try {
    return window.localStorage.getItem(ANALYTICS_IGNORE_KEY) !== 'true'
  } catch {
    // A blocked browser store must not bypass an internal/test opt-out.
    return false
  }
}
